import { render } from "./MarqueUltraLink.vue?vue&type=template&id=ccd2d6da"
import script from "./MarqueUltraLink.vue?vue&type=script&lang=js"
export * from "./MarqueUltraLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__